import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const COMPANY_GROUP_UPDATE_RESOURCE = "company-group" as const;
export const COMPANY_GROUP_UPDATE_API_PATH = `/v1/${COMPANY_GROUP_UPDATE_RESOURCE}/{uuid}` as const;

export type CompanyGroupUpdateBody =
  paths[typeof COMPANY_GROUP_UPDATE_API_PATH]["patch"]["requestBody"]["content"]["application/json"];
export type CompanyGroupUpdateResponse =
  paths[typeof COMPANY_GROUP_UPDATE_API_PATH]["patch"]["responses"][200]["content"]["application/json"];

export const useCompanyGroupUpdateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<CompanyGroupUpdateResponse, Error, CompanyGroupUpdateBody & { uuid: string }>({
    mutationFn: async ({ uuid, ...rest }) => {
      const response = await alphartisApiAxios.patch<CompanyGroupUpdateResponse>(
        `/v1/${COMPANY_GROUP_UPDATE_RESOURCE}/${uuid}`,
        rest,
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [COMPANY_GROUP_UPDATE_RESOURCE],
      });
    },
  });
};
